import { render, staticRenderFns } from "./BotNotificacoes.vue?vue&type=template&id=d16bd8c6&scoped=true"
import script from "./BotNotificacoes.vue?vue&type=script&lang=js"
export * from "./BotNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./BotNotificacoes.vue?vue&type=style&index=0&id=d16bd8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16bd8c6",
  null
  
)

export default component.exports